import { render, staticRenderFns } from "./tw-frame-fukidashi.vue?vue&type=template&id=51446d5c&scoped=true"
import script from "./tw-frame-fukidashi.vue?vue&type=script&lang=js"
export * from "./tw-frame-fukidashi.vue?vue&type=script&lang=js"
import style0 from "./tw-frame-fukidashi.vue?vue&type=style&index=0&id=51446d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51446d5c",
  null
  
)

export default component.exports